import Layout from '@/components/layout/Layout';
import { FC, useRef } from 'react';
import { parseISO, format } from 'date-fns';
import ReviewsList from '@/components/ui/reviews-list/ReviewsList';
import FormReview from '@/components/ui/form-review/FormReview';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import BlogBook from './blog-book/BlogBook';
// import RatingStars from '@/components/ui/rating-stars/RatingStars';
import { IBlogDetail } from '@/interfaces/blogDetail.interface';
import { IBlogBooks } from '@/interfaces/blogBooks.interface';
import AdvancedSearchBar from '@/components/ui/advanced-search-bar/AdvancedSearchBar';
import RatingStars from '@/components/ui/book-info/rating-stars/RatingStars';
import SocialsBar from '@/components/ui/socials-bar/SocialsBar';
import CardStats from '@/components/ui/card-stats/CardStats';
import BlogJsonMarkup from '@/components/ui/blog-json-markup/BlogJsonMarkup';
import { getFirstLetterCaps } from '@/helpers/helpers';
import styles from './BlogDetail.module.scss';

interface ReviewsDetailPage {
  blog: IBlogDetail;
  books: IBlogBooks;
}

const BlogDetail: FC<ReviewsDetailPage> = ({ blog, books }) => {
  const refReviewForm = useRef<HTMLDivElement>(null);

  const metatagsCheck = (text: string): string => {
    if (text && text.includes('seo')) {
      return text.split('seo')[1].slice(1);
    }
    return text;
  };

  const SEO_TITLE = metatagsCheck(blog.seo_title);
  const SEO_DESCRIPTION = blog.seo_description ? `${metatagsCheck(blog.seo_description)}. Читайте полезные статьи на сайте Fantasy Worlds` : `Читайте полезные статьи на сайте Fantasy Worlds`;
  const SEO_CANONICAL = `/blog/${blog.alias}`;

  const createMarkup = (c: string) => {
    return { __html: c };
  };

  const blogTitle = getFirstLetterCaps(blog?.title);

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL}>
      <BlogJsonMarkup title={blog.title} description={blog.description} seoTitle={blog.seo_title} />
      <Breadcrumbs firstPageName="Блог" firstPageAlias="/blog/" secondPageName={blogTitle} />
      <AdvancedSearchBar />

      <div className={styles.blogDetail}>
        <>
          <h1 className={styles.blogDetail__title}>{blogTitle}</h1>

          <div className={styles.blogDetail__content}>
            {blog.img && <img className={styles.blogDetail__contentImg} src={`/images/blog/${blog.img}`} alt="logo" width="267" height="34" />}
            <div className={`${styles.blogDetail__contentTxt} ${styles.blogDetail__content_clearFix}`} dangerouslySetInnerHTML={createMarkup(blog.data)}></div>
          </div>

          <div className={styles.blogDetail__ratingWrap}>
            <div className={styles.blogDetail__rating}>
              <RatingStars rating={blog.rating} title="Оценить:" id={blog.id} isBlogPage />
            </div>
            <SocialsBar bookLink={`/blog/${blog.alias}`} />
          </div>

          <div className={styles.blogDetail__stats}>
            <CardStats createdAt={blog.created_at ? blog.created_at : ''} rating={blog.rating ? blog.rating : 0} reviews={blog.reviews ? blog.reviews.length : 0} />
          </div>

          {books.books && books.books.length > 1 && (
            <div className={styles.blogDetail__books}>
              <div className={styles.blogDetail__booksTitle}>Книги блога</div>
              <div className={styles.blogDetail__list}>
                {books.books.slice(0, 5).map((item) => (
                  <BlogBook
                    key={item.book_id}
                    id={item.book_id}
                    externalId={item.external_id}
                    alias={item.alias}
                    rating={item.rating}
                    title={item.title}
                    authorFirstName={item.author.first_name}
                    authorMiddleName={item.author.middle_name}
                    authorLastName={item.author.last_name}
                    authorAlias={item.author.id}
                    reviews={item.reviews_count}
                  />
                ))}
              </div>
            </div>
          )}

          {blog.reviews && blog.reviews.length > 0 && (
            <>
              <div className={styles.blogDetail__booksTitle}>Отзывы</div>
              <ReviewsList isBlogPage reviews={{ data: blog.reviews } as any} />
            </>
          )}

          <div className={styles.blogDetail__reviewForm} ref={refReviewForm}>
            <div className={styles.blogDetail__booksTitle}>Оставить отзыв</div>
            <FormReview bookId={blog.id} bookAlias="" noMargin isBlogPage />
          </div>
        </>
      </div>
    </Layout>
  );
};

export default BlogDetail;
